import { c as _c } from "react/compiler-runtime";
import { isAfter } from 'date-fns';
import { useContext } from 'react';
import styled, { css } from 'styled-components';
import getThemes from '@hookdeck/theme/src/themes';
import Icon from '../../common/base/Icon';
import Link from '../../common/base/Link';
import Text from '../../common/base/Text';
import Tooltip from '../../common/base/Tooltip';
import { Div } from '../../common/helpers/StyledUtils';
import { DashboardContext } from './DashboardContext';
const StyledCancellationBanner = styled.div(({
  theme: current_theme
}) => {
  const themes = getThemes();
  const theme = current_theme.mode === 'light' ? themes.dark : themes.light;
  return css`
    background-color: ${theme.colors.surface.base.background};
    color: ${theme.colors.on.neutral.primary_neutral};
    height: 32px;
    position: sticky;
    top: 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 ${({
    theme
  }) => theme.spacing(4)};
    z-index: ${theme.zindex.fixed};

    a,
    button {
      color: ${theme.colors.on.neutral.primary_neutral};
      text-wrap: nowrap;

      span {
        color: inherit !important;
      }

      &:hover,
      & > * {
        background-color: inherit;
        cursor: pointer;
      }
    }

    & > div:first-of-type,
    & > div:last-of-type {
      width: 150px;
    }

    @media (max-width: 835px) {
      .cancellation-description {
        display: none;
      }
    }
  `;
});
export function QuotaEnforcementBanner() {
  const $ = _c(9);
  const {
    subscription
  } = useContext(DashboardContext);
  if (!subscription?.limit_exceeded_at && !subscription?.quota_enforcement_at) {
    return null;
  }
  if (subscription?.quota_enforcement_at) {
    const is_enforcement_active = isAfter(new Date(), new Date(subscription.quota_enforcement_at));
    if (is_enforcement_active) {
      let t0;
      if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = <Div flex={{
          gap: 1,
          align: "center"
        }}><Icon icon="info" /><Text bold={true} text_wrap={false}>Plan limit exceeded - events cancelled</Text></Div>;
        $[0] = t0;
      } else {
        t0 = $[0];
      }
      let t1;
      let t2;
      let t3;
      if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = {
          gap: 1,
          align: "center",
          justify: "center"
        };
        t2 = <span className="cancellation-description">Event delivery suspended - upgrade to resume.</span>;
        t3 = <Link href="/settings/organization/plans" icon="link">Upgrade now</Link>;
        $[1] = t1;
        $[2] = t2;
        $[3] = t3;
      } else {
        t1 = $[1];
        t2 = $[2];
        t3 = $[3];
      }
      let t4;
      if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = <Div flex={t1}>{t2}{t3}<Tooltip tooltip={<>Requests continue to be ingested, but new events are created with CANCELLED status and will not be delivered. After upgrading, you can bulk retry cancelled events from the Events page.</>}><Icon icon="info" small={true} /></Tooltip></Div>;
        $[4] = t4;
      } else {
        t4 = $[4];
      }
      let t5;
      if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = <StyledCancellationBanner>{t0}{t4}<Div flex={{
            gap: 1,
            align: "center",
            justify: "flex-end"
          }} /></StyledCancellationBanner>;
        $[5] = t5;
      } else {
        t5 = $[5];
      }
      return t5;
    }
  }
  if (subscription?.limit_exceeded_at) {
    let t0;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
      t0 = <Div flex={{
        gap: 1,
        align: "center"
      }}><Icon icon="info" /><Text bold={true} text_wrap={false}>Plan limit exceeded</Text></Div>;
      $[6] = t0;
    } else {
      t0 = $[6];
    }
    let t1;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <Div flex={{
        gap: 1,
        align: "center",
        justify: "center"
      }}><span className="cancellation-description">Your plan limit has been exceeded.</span><Link href="/settings/organization/plans" icon="link">Upgrade now</Link></Div>;
      $[7] = t1;
    } else {
      t1 = $[7];
    }
    let t2;
    if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = <StyledCancellationBanner>{t0}{t1}<Div flex={{
          gap: 1,
          align: "center",
          justify: "flex-end"
        }} /></StyledCancellationBanner>;
      $[8] = t2;
    } else {
      t2 = $[8];
    }
    return t2;
  }
  return null;
}